import { Component, OnInit, ViewChild } from '@angular/core';


@Component({
  selector: 'app-commission-config',
  templateUrl: './commission-config.component.html',
  styleUrls: ['./commission-config.component.scss']
})
export class CommissionConfigComponent implements OnInit {

  constructor() {	}

	ngOnInit() {}
}